import axios from 'axios'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
import { ToastProvider } from './components/ui/Toast/Toast'
import { EventProvider } from './context/EventContext'
import { NotificationsProvider } from './context/NotificationsContext'
import reportWebVitals from './reportWebVitals'
import './styles/global.scss'

// Adjunta el token JWT a las peticiones dirigidas a nuestra API (necesario para
// las rutas protegidas con passport/isAdmin). Se limita a la URL de la API para
// no enviar la cabecera Authorization a servicios de terceros (p.ej. el clima).
const API_URL = process.env.REACT_APP_API_URL
axios.interceptors.request.use(config => {
  const token = localStorage.getItem('token')
  if (token && API_URL && config.url && config.url.startsWith(API_URL)) {
    config.headers = config.headers || {}
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  <BrowserRouter>
    <ToastProvider>
      <NotificationsProvider>
        <EventProvider>
          <App />
        </EventProvider>
      </NotificationsProvider>
    </ToastProvider>
  </BrowserRouter>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
